import { FANTASY_CONSTANTS } from '@pff-consumer/schema'

export type DSTId = keyof typeof FANTASY_CONSTANTS.TEAMS

export const mapDSTIdToTeamAbbrev = (DSTId: DSTId) => {
  return FANTASY_CONSTANTS.TEAMS[DSTId]
}
